import { CountdownTimer } from "../countdown-timer";
import { HeaderReflectionProps } from "./types";
import "./style.scss";
import { SidePanel } from "../../../FuturebilityCockpit/components/SidePanel";
import TopicScore from "../topic-score";
import { useState } from "react";
import { CloseIcon } from "../header-solution/icons";
import { MenuIcon } from "./icons/menu-icon";
import round from "lodash-es/round";

export function HeaderReflection({
  totalProgress,
  topicProgress,
  currentQuestion,
  totalQuestions,
  topic,
  countdownTime,
  itemizedList,
}: HeaderReflectionProps) {
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const handleInfoOpen = () => {
    setIsInfoOpen(!isInfoOpen);
  };

  return (
    <>
      <header className="tg_header module2">
        <div className="header-content tg_column">
          <div className="progress-section">
            <CountdownTimer countdownTime={countdownTime} />
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${totalProgress}%` }}
              ></div>

              <div
                className="progress-secondary"
                style={{
                  left: `${totalProgress}%`,
                  width: `${topicProgress}%`,
                }}
              ></div>
            </div>
          </div>
          {!!(currentQuestion && totalQuestions) && topic?.name ? (
            <div className="topic-info">
              <span className="leadership-text">{topic!.name}</span>
              <span className="topic-label" />
              <span className="progress-counter">
                {currentQuestion} / {totalQuestions}
              </span>
            </div>
          ) : (
            topic && (
              <div className="topic-score-wrapper">
                <TopicScore topic={topic} />
                {itemizedList && Object.keys(itemizedList).length > 0 && (
                  <div className="list-circle" onClick={handleInfoOpen}>
                    <MenuIcon />
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </header>
      {isInfoOpen && (
        <SidePanel active={true} direction="right">
          <div className="header-reflection-side-panel">
            <div className="top-row">
              <CloseIcon onClick={() => setIsInfoOpen(!isInfoOpen)} />
            </div>
          </div>
          {itemizedList && Object.keys(itemizedList).length > 0 && (
            <div className="content-side-panel">
              <p className="header">{itemizedList.title}</p>
              <div className="items-list">
                {itemizedList.items.map((item, i) => (
                  <div className="score-item" key={i}>
                    <span>{item.title}</span>
                    <span>{round(item.score)}%</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </SidePanel>
      )}
    </>
  );
}
